import React from "react";

export const SubMenuHeadline = ({ title }) => {
  return title && <h2 className="text-gray-600">{title}</h2>;
};
